
import React, { useEffect, useState } from 'react';
import { Trophy, X } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface TrophyNotificationProps {
  isVisible: boolean;
  trophyTitle: string;
  onDismiss: () => void;
}

const TrophyNotification: React.FC<TrophyNotificationProps> = ({
  isVisible,
  trophyTitle,
  onDismiss
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setShow(false);
        setTimeout(onDismiss, 300);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);

  if (!isVisible && !show) return null;

  return (
    <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
      show ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
    }`}>
      <Card className="w-80 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center">
              <Trophy size={20} className="text-white" />
            </div>
            
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-yellow-800 dark:text-yellow-200">
                Reward Claimed! 🎉
              </h3>
              <p className="text-sm text-yellow-700 dark:text-yellow-300 mt-1">
                You've claimed "{trophyTitle}"
              </p>
            </div>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setShow(false);
                setTimeout(onDismiss, 300);
              }}
              className="flex-shrink-0 h-6 w-6 p-0 text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-200"
            >
              <X size={14} />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TrophyNotification;
